module.exports = __webpack_public_path__ + "b3889a44bb306c474a332dc8a8d9c10f.svg";